const ALERT_MESSAGE = {
    VETSOURCE_SYNC_INPROGRESS:
        "Patient and client information is currently syncing with Vetsource. You may proceed with any actions once the syncing process is complete."
};

const MEDICAL_CREATE = {
    YES: 1,
    NO: 0
};

export default {
    MEDICAL_CREATE,
    ALERT_MESSAGE
};
